module.exports = __webpack_public_path__ + "media/D2 Plaza 6.833500da.mp3";